module.exports = __webpack_public_path__ + "static/media/pallet-alt.e369ad5b.svg";